



































































import {Component, Prop, Vue} from 'vue-property-decorator';
import JdiContent from "@/components/JdiContent.vue"
import JdiStatus from "@/components/JdiStatus.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdiDocs from "@/components/JdiDocs.vue"
import JdsNametag from "@/design-system/constructs/Nametag/JdsNametag.vue"
import {Nametag as NametagEntity} from "@/design-system/constructs/Nametag/nametag.entity"
import faker from "@faker-js/faker"


@Component({
    components: {
        JdsNametag,
        JdiDocs, JdiPreview, JdiStatus, JdiContent
    }
})
export default class Nametag extends Vue {
    selectExample = 0

    unitContext = false

    samples: Array<NametagEntity> = []

    mounted() {
        for (let i = 0; i < 10; i++) {
            const name = [faker.name.firstName(), faker.name.lastName()]
            this.samples.push({
                name: faker.name.findName(name[0], name[1]),
                email: faker.internet.email(name[0], name[1]),
                // avatar: faker.internet.avatar(),
                // avatarColor: faker.internet.color(),
                isJobillaStaff: true,
                unit: 'Jobilla Finland',
                team: 'Admin',
                role: 'Developer',
                setupCompletedAt: faker.date.past(5),
                lastActiveAt: faker.date.recent(3),
            })
        }

        this.samples.push({
            name: 'Per-Ole Åkesson-Voss',
            email: 'test@example.com',
            // avatar: faker.internet.avatar(),
            // avatarColor: faker.internet.color(),
            isJobillaStaff: true,
            unit: 'Jobilla Finland',
            team: 'Admin',
            role: 'Developer',
            setupCompletedAt: faker.date.past(5),
            lastActiveAt: faker.date.recent(3),
        })
        this.samples.push({
            name: '小鳥遊',
            email: 'test@example.com',
            // avatar: faker.internet.avatar(),
            // avatarColor: faker.internet.color(),
            isJobillaStaff: true,
            unit: 'Jobilla Finland',
            team: 'Admin',
            role: 'Developer',
            setupCompletedAt: faker.date.past(5),
            lastActiveAt: faker.date.recent(3),
        })
        this.samples.push({
            name: 'Leo Sjöberg (Jobilla Admin User)',
            email: 'test@example.com',
            avatar: faker.internet.avatar(),
            // avatarColor: faker.internet.color(),
            isJobillaStaff: true,
            unit: 'Jobilla Finland',
            team: 'Admin',
            role: 'Developer',
            setupCompletedAt: faker.date.past(5),
            lastActiveAt: faker.date.recent(3),
        })
    }
}
